import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import appMockup from '../../assets/app-icon-1024.png';
import StoreBadges from '../StoreBadges/StoreBadges';
import './Hero.css';

const Hero = () => {
  const [appStats, setAppStats] = useState({ rating: null, reviews: null });

  useEffect(() => {
    const fetchAppStats = async () => {
      try {
        // Use the App Store ID to fetch app data
        const response = await fetch('https://itunes.apple.com/lookup?id=6755897013'); 
        const data = await response.json();
        
        if (data.resultCount > 0) {
          const app = data.results[0];
          // Only show ratings if there are reviews
          if (app.userRatingCount && app.userRatingCount > 0 && app.averageUserRating) {
            setAppStats({
              rating: app.averageUserRating.toFixed(1),
              reviews: app.userRatingCount
            });
          }
        }
      } catch (error) {
        console.log("Could not fetch app stats, hiding rating section.");
      }
    };

    fetchAppStats();
  }, []);

  return (
    <section id="home" className="hero">
      {/* Video Background */}
      <div className="hero-video-container">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="hero-video"
        >
          <source src="/background-1.mp4" type="video/mp4" />
        </video>
        <div className="hero-video-overlay"></div>
      </div>
      
      <div className="hero-container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <span>AI-Powered Trading Coach</span>
          </div>
          <h1>
            Master Markets with <br />
            <span className="neon-text">Personalized AI</span>
          </h1>
          <p className="hero-subtitle">
            Your intelligent trading companion. Journal trades, get instant chart analysis, and unlock behavioral insights to elevate your performance.
          </p>
          
          <div className="hero-cta">
            <StoreBadges />
            
            <Link 
              to="/howitworks"
              className="btn btn-secondary glass-btn"
            >
              <i className="fas fa-play-circle"></i> See How It Works
            </Link>
          </div>

          {appStats.rating && (
            <div className="stats-row glass-panel">
              <div className="stat-item">
                <span className="stat-value">{appStats.rating}</span>
                <span className="stat-label">App Store Rating</span>
              </div>
              <div className="stat-separator"></div>
              <div className="stat-item">
                <span className="stat-value">{appStats.reviews}</span>
                <span className="stat-label">Reviews</span>
              </div>
            </div>
          )}
        </motion.div>
        
        <motion.div 
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="app-mockup-container">
            <div className="glow-effect"></div>
            <img src={appMockup} alt="LunarLog AI App Interface" className="mockup-img" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
